export type CxArg = false | null | string | undefined

/** Joins class names while ignoring empty conditional values. */
export function cx(...args: CxArg[]): string {
  return args.filter(Boolean).join(' ')
}
